import React, { useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import Snackbar from "../../snackbar";
import { useRecordContext } from "react-admin";

  const CopyText = (props) => {
  const record = useRecordContext()
  console.log("props copy text", props);
  const displayText =
    "https://clickitapp.io/product/" + record.material_short_code;
  const [text, setText] = useState("hi hiw are");
  const [isCopied, setIsCopied] = useState(false);

  const onCopyText = () => {
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 1000);
  };

  return (
    <CopyToClipboard text={displayText} onCopy={onCopyText}>
      <div>
        <button className="copy-to-clipboard-btn">Copy to Clipboard</button>
        {isCopied && <Snackbar message="Copied!" />}
      </div>
    </CopyToClipboard>
  );
}

export default CopyText;
